<template>

<div>
    <div class="card info-flight">
        <div class="main-info-wrap">
            <div class="row info-wrap">
                <!-- <div class="row"> -->
                    <div class="col">

                    </div>
             <div class="col">
                
               <div class="row">
                   <div class="col"> 
               {{flightObj.name}}
               </div>
                   <!-- <div class="col">  -->
                <cStarRating :rating="Number(flightObj.rating)"></cStarRating>
                 <!-- </div> -->
               
                </div>
                <br />
                <cAmenities :amenitiesLs="flightObj.amenities"></cAmenities>
               {{flightObj.address.lines+' | '}} {{flightObj.distance.distance+' '}}{{flightObj.distance.distanceUnit}}
            </div>
            <!-- </div> -->
                <!-- <div class="flight-name">
                    <div v-if="flightObj" class="logo">
                        
                        
                    </div>
                   

                    <div class="name">
                            {{flightObj[0].flight.opAirline|airlineName}} |  
                        <span class="flight-code">{{flightObj[0].flight.FlightNo}}</span>
                        <span class="flight-code">
                      {{flightObj && flightObj[0] && flightObj[0].flight.DepDate|
                      formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}
                    </span>
                    
                    </div>
                </div>

                <div class="time-place-wrap">
                    <div class="left">
                        <div class="time" v-c-tooltip.hover="{
                      content:`${dateFormatInTooltip(flightObj[0].flight.DepDate)}
                       `,}">
                            {{flightObj && flightObj[0] &&
                            flightObj[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                        </div>
                        <div class="place-code">
                            {{flightObj &&
                            flightObj[0] &&
                            flightObj[0].flight.DepAirport}}
                        </div>
                        <div class="place">
                            {{flightObj && flightObj[0] &&
                            flightObj[0].flight.DepAirport | cityName}}
                        </div>
                    </div>
                    <div class="center">
                    <span>
                      {{flightObj && flightObj[0] && flightObj[0].flight.TotalDuration|
                      convertToHrMin("minutes","H [h] mm [m]")}}
                    </span>
                        <img src="@/assets/mf/img/svg/icons/flying-flight.svg" alt/>



                      <span v-if="!isStopsForNonMyanmar"
                              class="stop"
                        >{{flightObj && flightObj[0].flight.no_of_stops && flightObj[0].flight.no_of_stops.name}}</span>
                        
                        <span v-else-if="isStopsForNonMyanmar && flightObj.length==1"
                                class="via"
                        >{{flightObj && flightObj[0] && flightObj[0].flight.Via_Obj}}</span>
                        <span v-else-if="isStopsForNonMyanmar && flightObj.length>1"
                                class="via"
                        ><span>{{flightObj && flightObj[0] && flightObj[0].flight.no_of_stops && flightObj[0].flight.no_of_stops.name}}</span>
                <span >{{flightObj[0].flight.Via_Obj != 'Non-Stop'?', '+flightObj[0].flight.Via_Obj:null}}</span></span>
                    </div>

                    <div class="right">
                        <div class="time" v-c-tooltip.hover="{
                    content:`${dateFormatInTooltip(flightObj[flightObj.length-1].
                    flight.ArrDate)}

                                `,
                            }">
                            {{flightObj && flightObj[flightObj.length-1] &&
                            flightObj[flightObj.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                            <span
                                    class="day" v-c-tooltip.hover="{
                              content:`${noOfDaysTooltip(flightObj[0].flight.no_of_days)}`,
                            }"
                            >{{ flightObj && flightObj[0] && flightObj[0].flight.no_of_days}}</span>
                        </div>
                        <div class="place-code">
                            {{flightObj && flightObj[flightObj.length-1] &&
                            flightObj[flightObj.length-1].flight.ArrAirport}}
                        </div>
                        <div class="place">
                            {{flightObj && flightObj[flightObj.length-1] &&
                            flightObj[flightObj.length-1].flight.ArrAirport | cityName}}
                        </div>
                    </div>
                </div>
                <div v-if="flightObj && flightObj[0] && flightObj[0].flight.baggage" class="luggage d-flex">
                    <img src="@/assets/mf/img/svg/icons/Suitcase_icon.svg" alt/>
                    <span>{{flightObj && flightObj[0] && flightObj[0].flight.baggage && flightObj[0].flight.baggage[0].weightinkg+' Kg'}}</span>
                </div> -->
            </div>
        </div>
        <div class="price-details-wrap">
            <div class="price-wrap">


                <div v-if="flightObj.rooms && flightObj.rooms[0] &&
                 flightObj.rooms[0].price && flightObj.rooms[0].price.totalAmount">
                    <!-- <table >

                        <tbody>
                        <tr v-for="(pUnit,pindex) in totalFlightObj"
                           :key="'pIdobagain'+pUnit.pId+pindex" :class="pUnit.selectStatus == noClass ? 'no-class'
                        :pUnit.selectStatus == selectedClass ? 'selected': pUnit.selectStatus == selectableClass ? 'selectable': 'disable'"
                           @click="pUnit.selectStatus == disableClass?click:$emit('updateflightls',pUnit)">
                            <td>
                                <div>
                                    <div @click="click" class="radio">
                                        <div role="group" class="custom-control custom-radio">
                                            <label v-if="pUnit.obFlight" for="c" class="custom-control-label">
                                                
                                                 {{pUnit.fareType ? '- '+
                                                pUnit.fareType : null}}
                                            </label>
                                            <label v-if="pUnit.ibFlight" for="c" class="custom-control-label">
                                               
                                                {{pUnit.fareType ? '- '+
                                                pUnit.fareType : null}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div
                                        class="currency"
                                >{{pUnit.clientPricing && pUnit.clientPricing.Currency}}
                                </div>
                            </td>
                            <td>
                                <div class="value">
                                    {{pUnit.clientPricing && pUnit.clientPricing.AdultPrice.Total |
                                    amountformat}}
                                </div>
                            </td>
                           
                        </tr>

                        </tbody>

                    </table> -->
                    {{flightObj.rooms[0].price.totalAmount}}

                </div>
               
            </div>
        </div>
       <!-- <cConnectingFlightInfo  v-if="toShowConnectingInfo" :selectedFlight="totalFlightObj"
            :isResultPage="true" :flightObject="flightObj"></cConnectingFlightInfo> -->
    </div>
    
 
</div>
</template>
<script>
import cStarRating from './cStarRating'
import cAmenities from './cAmenities';
    import BaseConfiguration from "../../../../config/base.js";
    import {
        COMPONENT_NAME,
        PATHNAME,DATE_TIME_FORMAT,
        FLIGHT_SELECTION_STATUS
    } from "../../../../util/constants";
import { mapGetters, mapActions } from "vuex";
// import cConnectingFlightInfo from "../../../components/result/cConnectingFlightInfo"
    export default {
        name: 'cHotelResultCard',
        components:{
            // cConnectingFlightInfo
            cStarRating,
            cAmenities
        },
        props: {
            flightObj: {
                type: Object | Array
            },
            totalFlightObj: {
                type: Object | Array
            },
           
        },
        data: () => ({
            isDebug : BaseConfiguration.isDebug,
            defaultALImg: BaseConfiguration.defaultALImg,
            isStopsForNonMyanmar: BaseConfiguration.isStopsForNonMyanmar,
            noOfMaxFare: BaseConfiguration.maxFareList,
            noClass: FLIGHT_SELECTION_STATUS.noClass,
            selectedClass: FLIGHT_SELECTION_STATUS.selected,
            selectableClass: FLIGHT_SELECTION_STATUS.selectable,
            disableClass: FLIGHT_SELECTION_STATUS.disable,
            isShowMore:false,
            toShowConnectingInfo: false,

        }),
        computed: {
             DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
        ...mapGetters("sResult", {
      GET_AIRLINES: 'GET_AIRLINES',
     
    }),
        },
        created(){
            // if(this.totalFlightObj.length!=0){
            //     this.toShowMore(this.totalFlightObj);
            // }
            
        },
        methods: {
            click(e) {
                e.preventDefault();
            },

            

            toShowMore(ptotalFlightObj) {
                // let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("toShowMore");
                  for (let index = 0; index < ptotalFlightObj.length; index++) {
                     if(ptotalFlightObj[index].selectStatus==1 && index>this.noOfMaxFare){
                         this.isShowMore=true;
                     }
                      
                  }
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_FLIGHTRESULTCARD,
                          "error in toShowMore",
                          err.toString(),
                          "toShowMore",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                //   return retValue;
           }, 
            ///to get date object in particular format

            dateFormatInTooltip(pDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("formatDate");
                    if (pDate != null) {
                        retValue = this.$options.filters.formatDate(
                            pDate,
                         
                            DATE_TIME_FORMAT.DAY_DATE_MONTH
                        );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_FLIGHTRESULTCARD,
                        "error in dateFormatInTooltip",
                        err.toString(),
                        "dateFormatInTooltip",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


            ///to get no of days tooltip
            noOfDaysTooltip(pNoofDays) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("noOfDaysTooltip");
                    if (pNoofDays) {
                        if (pNoofDays == 1) {
                            retValue = "Flight lands the next day";
                        } else {
                            pNoofDays = pNoofDays.replace("+", "");
                            retValue = "Flight lands after " + pNoofDays + " days";
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_FLIGHTRESULTCARD,
                        "error in noOfDaysTooltip",
                        err.toString(),
                        "noOfDaysTooltip",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

        }
    };
</script>
<style>
    .list-item {
        display: inline-block;
        margin-right: 10px;
    }

    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }

    .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
    {
        opacity: 0;
        transform: translateY(30px);
    }
    span.provider {
    font-size: 10px;
    color: white;
}
.sticky-with-card-wrap {
    top: 75px;
    position: absolute;
  top: 20px;
  background: grey;
  left: 0px;
  z-index: 9999;
  color: white;
  height: 28px;
  display: flex;
  align-items: center;
  border-radius: 0px 0px 8px 0px;
  padding: 0px 50px;
  }

</style>